module.exports = __webpack_public_path__ + "img/marker-icon01@2x.00e3e0fb.png";